/**
 * makeStyles / createStyles backward-compat shim for MUI v7.
 * Wraps tss-react to provide the exact MUI v4 makeStyles API.
 *
 * Before: import { makeStyles } from '@material-ui/core/styles'  (v4)
 * After:  import { makeStyles } from '@Compat/makeStyles'         (v7)
 *
 * Usage unchanged: const useStyles = makeStyles((theme) => ({ ... }))
 *                  const classes = useStyles();
 */
import { makeStyles as tss } from 'tss-react/mui';

// Return type uses Record<string, string> to avoid TypeScript inference issues
// with ClassKey being incorrectly inferred as Theme in some patterns.
export function makeStyles<_ClassKey = any, _Options = any>(
  stylesCreator: ((theme: any) => Record<string, any>) | Record<string, any>,
  _options?: any
): (...args: any[]) => Record<string, string> {
  const fn = typeof stylesCreator === 'function' ? stylesCreator : () => stylesCreator;
  const useStylesHook = tss()(fn as any);
  return function useCompatStyles(..._args: any[]) {
    return useStylesHook().classes;
  };
}

/** No-op passthrough (MUI v5+ doesn't require createStyles for inference). */
export function createStyles<T extends Record<string, any>>(styles: T): T {
  return styles;
}
